import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './Header';
import Footer from './Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Header />
    <div style={{margin: 'auto', width: '50%'}}>
      <p style={{color: 'white'}}>***NOTICE***</p>
      <p style={{color: 'white'}}>If you change the number of images in the slideshow or the image type, you may need click the "qc" or "ldr" buton 1 to 2 times in order to get the images to show.</p>
    </div>
    <App />
    <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
